import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const Home = (store) => ({
  path: ROUTE.HOME,
  exact: true,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'home',
    loadReducer: () => import('./HomeState'),
    loadComponent: () => import('./HomeContainer'),
  })
})

export default Home
